import { lazy } from "react";

export const NewDomainTagPage = lazy(() => import("./newDomainTagPage"));
